// Redux action to show the environment info modal before deploy
export const showEnvironmentDeployInfoModal = () => ({});
